// import { useState, useEffect } from "react";
// import {
//     AssignPhotographerToBookingAPI,
//     // GetToFloatPhotographersgAPI,
//     SortPhotographersAPI,
// } from "../../../../../../utils/APIs/bookingsApis";
// import { getServicesAPI } from "../../../../../../utils/APIs/servicesApis";
// import { toast } from "react-toastify";
// import { GetToFloatPhotographersgAPI } from "../../../../../../utils/APIs/hourlyBookingsApis";

// const LIMIT = 10;

// const useHourlyFloat = ({ booking, isOpen, onClose, refetchData }) => {
//     // ─── State ──────────────────────────────────────────────────────────────────
//     const [photographers, setPhotographers]               = useState([]);
//     const [photographerSearch, setPhotographerSearch]     = useState("");
//     const [selectAllChecked, setSelectAllChecked]         = useState(false);
//     const [loadingPhotographers, setLoadingPhotographers] = useState(false);
//     const [loadingAddBooking, setLoadingAddBooking]       = useState(false);
//     const [services, setServices]                         = useState([]);
//     const [isLock, setIsLock]                             = useState(false);
//     const [page, setPage]                                 = useState(1);
//     const [total, setTotal]                               = useState(0);
//     const [filters, setFilters]                           = useState({ rating: "", expertise: "", category: "" });
//     const [formData, setFormData]                         = useState({ photographerIds: [] });

//     const totalPages = Math.ceil(total / LIMIT);

//     // ─── Derived ─────────────────────────────────────────────────────────────────
//     const filteredPhotographers = (photographers || []).filter((p) =>
//         p.name?.toLowerCase().includes(photographerSearch.toLowerCase()) ||
//         (p.mobileNumber || p.phone)?.includes(photographerSearch)
//     );

//     // ─── Fetch photographers ──────────────────────────────────────────────────────
//     const fetchPhotographers = async (pageNo = page) => {
//         try {
//             setLoadingPhotographers(true);
//             let res;

//             if (filters.rating || filters.expertise || filters.category) {
//                 res = await SortPhotographersAPI(filters, pageNo, LIMIT, booking.bookingId);
//             } else {
//                 res = await GetToFloatPhotographersgAPI(pageNo, LIMIT, booking.bookingId);
//             }

//             setPhotographers(res?.data?.data || []);
//             setTotal(res?.data?.meta?.total ?? res?.data?.data?.length ?? 0);
//             setPage(res?.data?.meta?.page || pageNo);
//             setIsLock(res?.data?.isLock || false);
//         } catch (error) {
//             console.error("Photographer fetch failed", error);
//         } finally {
//             setLoadingPhotographers(false);
//         }
//     };

//     // ─── Fetch services ───────────────────────────────────────────────────────────
//     const fetchServices = async () => {
//         try {
//             const res = await getServicesAPI();
//             setServices(res?.data?.data || []);
//         } catch (err) {
//             console.error("Failed to fetch services", err);
//         }
//     };

//     // ─── Effects ──────────────────────────────────────────────────────────────────
//     useEffect(() => {
//         if (!isOpen) return;
//         fetchPhotographers(page);
//         setSelectAllChecked(false);
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [isOpen, page]);

//     useEffect(() => {
//         if (!isOpen) return;
//         fetchPhotographers(1);
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [filters, isOpen]);

//     useEffect(() => {
//         if (!isOpen) return;
//         fetchServices();
//     }, [isOpen]);

//     // ─── Handlers ─────────────────────────────────────────────────────────────────
//     const handleSelectAll = async (e) => {
//         const checked = e.target.checked;
//         setSelectAllChecked(checked);

//         if (checked) {
//             try {
//                 const res = await GetToFloatPhotographersgAPI(1, total, booking.bookingId);
//                 const allIds = res?.data?.data?.map((p) => p._id) || [];
//                 setFormData((prev) => ({ ...prev, photographerIds: allIds }));
//             } catch (error) {
//                 console.error("Failed to fetch all photographers", error);
//             }
//         } else {
//             setFormData((prev) => ({ ...prev, photographerIds: [] }));
//         }
//     };

//     const handlePhotographerToggle = (id, checked) => {
//         setFormData((prev) => ({
//             ...prev,
//             photographerIds: checked
//                 ? [...prev.photographerIds, id]
//                 : prev.photographerIds.filter((pid) => pid !== id),
//         }));
//         if (selectAllChecked) setSelectAllChecked(false);
//     };

//     const resetForm = () => {
//         setFormData({ photographerIds: [] });
//         setSelectAllChecked(false);
//         setPhotographerSearch("");
//     };

//     const handleFilterChange = (key, value) => {
//         setFilters((prev) => ({ ...prev, [key]: value }));
//     };

//     const resetFilters = () => {
//         setFilters({ rating: "", expertise: "", category: "" });
//         setPhotographerSearch("");
//         setPage(1);
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (formData.photographerIds.length === 0) {
//             toast.error("Please select at least one photographer");
//             return;
//         }

//         try {
//             setLoadingAddBooking(true);

//             const payload = { bookingId: booking.bookingId };
//             if (formData.photographerIds.length === 1) {
//                 payload.photographerId = formData.photographerIds[0];
//             } else {
//                 payload.photographerIds = formData.photographerIds;
//             }

//             const response = await AssignPhotographerToBookingAPI(payload);

//             if (response?.data?.success) {
//                 toast.success(response?.data?.message || "Photographer request sent successfully!");
//                 refetchData();
//                 resetForm();
//                 onClose();
//             } else {
//                 toast.error(response?.data?.message || "Failed to send request!");
//             }
//         } catch (error) {
//             console.error("Assign Booking Error:", error);
//             toast.error("Something went wrong");
//         } finally {
//             setLoadingAddBooking(false);
//         }
//     };

//     return {
//         // State
//         photographers,
//         filteredPhotographers,
//         photographerSearch,
//         setPhotographerSearch,
//         selectAllChecked,
//         loadingPhotographers,
//         loadingAddBooking,
//         services,
//         isLock,
//         page,
//         setPage,
//         total,
//         totalPages,
//         filters,
//         formData,
//         LIMIT,
//         // Handlers
//         handleSelectAll,
//         handlePhotographerToggle,
//         handleFilterChange,
//         resetFilters,
//         handleSubmit,
//         resetForm,
//     };
// };

// export default useHourlyFloat;


import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { getServicesAPI } from "../../../../../../utils/APIs/servicesApis";
import { AssignPhotographerToBookingAPI } from "../../../../../../utils/APIs/bookingsApis";
import { axiosInstance } from "../../../../../../utils/APIs/commonHeadApiLogic";

/**
 * Top-level modal hook.
 * Owns: services fetch, per-role selection tracking, and final submit.
 * Each accordion manages its OWN list/pagination via useRoleAccordion.
 */
const useHourlyFloat = ({ booking, isOpen, onClose, refetchData }) => {
    const [loadingAddBooking, setLoadingAddBooking] = useState(false);
    const [services, setServices]                   = useState([]);

    const [selectedPackageIndex, setSelectedPackageIndex] = useState(0);

    // ─── Per-package, Per-role selected IDs ──────────────────────────────────────
    // Shape: { [packageIndex]: { photographer: [], videographer: [], ... } }
    const [allPackagesSelections, setAllPackagesSelections] = useState({});
    const [allPackagesDetails, setAllPackagesDetails] = useState({});

    // Current package selections helper
    const roleSelections = allPackagesSelections[selectedPackageIndex] || {
        photographer:  [],
        videographer:  [],
        editor:        [],
        lightingSetup: [],
    };
    const roleDetails = allPackagesDetails[selectedPackageIndex] || {};

    // Called by each RoleAccordion when its selection changes
    const handleRoleSelectionChange = (roleKey, ids, details) => {
        setAllPackagesSelections((prev) => ({
            ...prev,
            [selectedPackageIndex]: {
                ...(prev[selectedPackageIndex] || {
                    photographer:  [],
                    videographer:  [],
                    editor:        [],
                    lightingSetup: [],
                }),
                [roleKey]: ids
            }
        }));
        if (details) {
            setAllPackagesDetails((prev) => ({
                ...prev,
                [selectedPackageIndex]: {
                    ...(prev[selectedPackageIndex] || {}),
                    [roleKey]: details
                }
            }));
        }
    };

    const [localBooking, setLocalBooking]           = useState(booking);
    const [refreshVersion, setRefreshVersion]       = useState(0);

    // ─── Fetch Booking Details ──────────────────────────────────────────────────
    useEffect(() => {
        if (!isOpen) return;
        (async () => {
            try {
                // Determine the correct ID to fetch (supports multiple field names from parent table)
                const targetId = booking.veroaBookingId || booking._id || booking.bookingId;
                if (!targetId) return;

                const res = await axiosInstance.get(`/api/admins/bookings/${targetId}`);
                if (res?.data?.data) {
                    setLocalBooking(res.data.data);
                }
            } catch (err) {
                console.error("Failed to fetch booking details", err);
            }
        })();
    }, [isOpen, refreshVersion, booking.veroaBookingId, booking._id, booking.bookingId]);

    // ─── Services ─────────────────────────────────────────────────────────────────
    useEffect(() => {
        if (!isOpen) return;
        (async () => {
            try {
                const res = await getServicesAPI();
                setServices(res?.data?.data || []);
            } catch (err) {
                console.error("Failed to fetch services", err);
            }
        })();
    }, [isOpen]);

    // ─── Reset ────────────────────────────────────────────────────────────────────
    const resetAll = () => {
        setAllPackagesSelections({});
        setAllPackagesDetails({});
    };

    const triggerRefresh = () => {
        setRefreshVersion(prev => prev + 1);
        refetchData?.();
    };

    // ─── Submit ───────────────────────────────────────────────────────────────────
    // ─── Individual Role Submit ──────────────────────────────────────────────────
    const handleRoleSubmit = async (roleKey, actionType, photographerDetails) => {
        const ids = roleSelections[roleKey];
        if (!ids || ids.length === 0) {
            toast.error(`Please select at least one ${roleKey}`);
            return;
        }

        try {
            setLoadingAddBooking(true);

            const payload = {
                bookingId: localBooking.veroaBookingId || localBooking._id || localBooking.bookingId,
                packageIndex: selectedPackageIndex,
                roleSelections: {
                    [roleKey]: ids
                },
                photographerDetails: photographerDetails,
                actionType: "request",
            };

            const response = await AssignPhotographerToBookingAPI(payload);

            if (response?.data?.success) {
                toast.success(response?.data?.message || "Request sent successfully!");
                triggerRefresh();
                setAllPackagesSelections((prev) => ({
                    ...prev,
                    [selectedPackageIndex]: {
                        ...(prev[selectedPackageIndex] || {}),
                        [roleKey]: []
                    }
                }));
            } else {
                toast.error(response?.data?.message || "Failed to process action!");
            }
        } catch (err) {
            console.error("request error:", err);
            toast.error("Something went wrong");
        } finally {
            setLoadingAddBooking(false);
        }
    };

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();

        const totalSelected = Object.values(roleSelections).flat().length;
        if (totalSelected === 0) {
            toast.error("Please select at least one person across any role");
            return;
        }

        try {
            setLoadingAddBooking(true);

            const combinedDetails = Object.values(roleDetails).flat().filter(Boolean);

            const payload = {
                bookingId: localBooking.veroaBookingId || localBooking._id || localBooking.bookingId,
                packageIndex: selectedPackageIndex,
                roleSelections: roleSelections,
                photographerDetails: combinedDetails,
                actionType: "request" // Always send as a request, never direct assign
            };

            const response = await AssignPhotographerToBookingAPI(payload);

            if (response?.data?.success) {
                toast.success(response?.data?.message || "Request sent successfully!");
                triggerRefresh();
                resetAll();
                onClose();
            } else {
                toast.error(response?.data?.message || "Failed to send request!");
            }
        } catch (err) {
            console.error("Assign error:", err);
            toast.error("Something went wrong");
        } finally {
            setLoadingAddBooking(false);
        }
    };

    return {
        services,
        loadingAddBooking,
        roleSelections,
        allPackagesSelections,
        selectedPackageIndex,
        setSelectedPackageIndex,
        handleRoleSelectionChange,
        handleSubmit,
        handleRoleSubmit,
        resetAll,
        refreshVersion,
        localBooking,
    };
};

// ─── Helper: build payload keys per role ─────────────────────────────────────


export default useHourlyFloat;